<template>
  <GenericHeader
    :retailerColor="retailerColor"
    :retailerLogo="retailerLogo"
    :hasContainer="true">
    <div v-if="!isLoading">
      <div class="background"></div>
      <div class="checkout-fallback-wrapper">
        <div class="left">
          <checkout-fallback-verify />
        </div>
        <div class="right">
          <checkout-data
            v-if="showCheckoutData"
            class="checkout-data"
            :order="order"
            :products="products"
            :user="user" />
        </div>
      </div>
    </div>
    <LockLoader :text="loaderText" v-else/>
  </GenericHeader>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Logger from '@/lib/logger';
import LockLoader from '@/components/common/LockLoader.vue';
import GenericHeader from '../components/GenericHeader.vue';
import CheckoutData from '../components/CheckoutData.vue';
import CheckoutFallbackVerify from '../components/CheckoutFallbackVerify.vue';

export default {
  name: 'checkout-fallback',
  components: {
    GenericHeader,
    CheckoutData,
    CheckoutFallbackVerify,
    LockLoader,
  },
  data: () => ({
    loaderText: 'Carregando seu pedido no Parcelex',
    retailerColor: '',
    retailerLogo: '',
  }),
  computed: {
    ...mapState('checkoutRedirect', [
      'order',
      'products',
      'user',
      'isLoading',
    ]),
    showCheckoutData() {
      return !(!this.order || !this.products || !this.user);
    },
  },
  methods: {
    ...mapActions('checkoutRedirect', [
      'error',
      'init',
    ]),
    errorHandler(error) {
      Logger.error(error);
      if (error && error.request && error.request.status === 400) {
        this.$router.replace({ name: 'checkout-error' });
      } else {
        if (this.goneToError) return;
        this.$router.replace({ name: 'checkout-error' });
        this.error(error);
      }
    },
  },
  mounted() {
    this.init(this.$route.query);
  },
};
</script>

<style lang="scss" scoped>
.checkout-fallback-wrapper {
  @extend .container;
  position: relative;
  min-height: calc(100vh - 50px);

  @media (min-width: $lg) {
    display: flex;
  }
  z-index: 10;
  .left {
    z-index: 10;
    min-width: 486px;
    max-width: 486px;
    background: #FFFFFF;
    min-height: calc(100vh - 50px);

    @media (min-width: $lg) {
      margin-right: 36px;
    }
  }
  .right {
    z-index: 10;
    background: var(--gray-100);
    width: 100%;

    .checkout-data {
      max-width: 370px;
    }
  }
  @media (max-width: $md) {
    .left {
      min-height: 100%;
      max-width: calc(100% - 48px);
    }
    .right {
      display: none;
    }
  }
}
.background {
  position: absolute;
  min-height: calc(100vh - 50px);
  width: 100%;
  z-index: 1;
  @media (min-width: $lg) {
    background: linear-gradient(90deg, #FFFFFF 60%, var(--gray-100) 40%);
  }
}
</style>
